/* Glowtech – INNEHÅLL. Byt texter, produkter och bildnamn här. Bilder: ladda upp under Assets med samma filnamn. */
window.GT_DATA = {
  brand: "Glowtech",

  // Tunn rad högst upp
  topbar: { locale: "SWE · SEK", center: "Fri frakt · 2–5 dagars leverans", link: { label: "Kontakta oss", href: "#kontakt" } },

  // Kategorimenyn under loggan. "tag" filtrerar produktgridet, "href" är en vanlig länk.
  tabs: [
    { label: "Alla produkter", tag: "*" },
    { label: "Nyheter", tag: "Nyheter" },
    { label: "Bästsäljare", tag: "Bästsäljare" },
    { label: "LED-masker", tag: "LED-masker" },
    { label: "Hudvård", tag: "Hudvård" },
    { label: "Paketpris", tag: "Paketpris" },
    { label: "Tillbehör", tag: "Tillbehör" },
    { label: "Presentkort", href: "#" }
  ],

  // Hamburgermenyn (mobil)
  menu: [
    { label: "Shop", groups: [
      { title: "Handla", links: [["Alla produkter", "#produkter"], ["Paketpris", "#produkter"], ["Bästsäljare", "#bastsaljare"], ["Nyheter", "#produkter"]] },
      { title: "Kategorier", links: [["LED-masker", "#produkter"], ["Hudvård", "#produkter"], ["Tillbehör", "#produkter"]] }
    ]},
    { label: "Ljusterapi", groups: [
      { title: "Ljus", links: [["Rött ljus", "#terapier"], ["Nära-infrarött", "#terapier"], ["Blått ljus", "#terapier"]] },
      { title: "Lär dig mer", links: [["Så fungerar LED", "#terapier"], ["Säkerhet", "#"]] }
    ]},
    { label: "Hjälp", groups: [
      { title: "Kundservice", links: [["Kontakta oss", "#"], ["Vanliga frågor", "#"]] },
      { title: "Order", links: [["Frakt och leverans", "#"], ["Retur och öppet köp", "#"]] }
    ]},
    { label: "Om oss", href: "#om-oss" }
  ],
  searchSuggestions: ["LED-mask", "Rött ljus", "Paketpris", "Tillbehör"],

  hero: {
    image: "hero.jpg",
    eyebrow: "Alla produkter",
    label: "Nyhet",
    title: "The Glow Edit",
    text: "Vår LED-mask med rött ljus, för en kvällsrutin som känns som ett besök på salongen. Tio minuter, hemma.",
    cta: { label: "Upptäck masken", href: "#produkter" }
  },

  products: [
    { name: "Glowtech LED-mask", image: "product-1.png", price: 2400, tags: ["LED-masker", "Bästsäljare"], href: "/products/glod-led-mask", variantId: 58099596198270 },
    { name: "Glowtech LED-mask 2-pack", image: "product-2.png", price: 4000, compareAt: 4800, tags: ["Paketpris", "Bästsäljare"], href: "/products/glod-led-mask", variantId: 58099596231038 },
    { name: "Produkt 3", image: "product-3.png", price: 999, tags: ["Hudvård", "Nyheter"], href: "#" },
    { name: "Produkt 4", image: "product-4.png", price: 1299, tags: ["Hudvård", "Bästsäljare"], href: "#" },
    { name: "Produkt 5", image: "product-5.png", price: 349, tags: ["Tillbehör"], href: "#" },
    { name: "Produkt 6", image: "product-6.png", price: 699, tags: ["LED-masker", "Nyheter"], href: "#" },
    { name: "Produkt 7", image: "product-7.png", price: 249, tags: ["Tillbehör"], href: "#" },
    { name: "Produkt 8", image: "product-8.png", price: 1899, tags: ["Hudvård"], href: "#" }
  ],

  duo: [
    { image: "promo-1.jpg", text: "Nyhet: Glowtech LED-mask är här", cta: "Köp nu", href: "/products/glod-led-mask" },
    { image: "promo-2.jpg", text: "Paketpris. Två masker för 4 000 kr", cta: "Köp nu", href: "/products/glod-led-mask" }
  ],

  therapies: {
    eyebrow: "Våra ljusterapier",
    items: [
      { image: "therapy-1.png", title: "Rött ljus", text: "Rött LED-ljus är det vanligaste ljuset i masker för hudvård hemma." },
      { image: "therapy-2.png", title: "Nära-infrarött ljus", text: "Längre våglängd som ofta kombineras med rött ljus." },
      { image: "therapy-3.png", title: "Blått ljus", text: "Kortare våglängd som används i rutiner för klarare hud." },
      { image: "therapy-4.png", title: "Hals och dekolletage", text: "Ljus för ett område som ofta glöms bort i hudvården." },
      { image: "therapy-5.png", title: "Ögonområdet", text: "Skonsam användning runt den tunna huden kring ögonen." },
      { image: "therapy-6.png", title: "Kvällsrutin", text: "Tio minuter ljus mellan rengöring och kräm." }
    ]
  },

  bestsellers: { title: "Bästsäljare", tag: "Bästsäljare", count: 3 },

  statement: {
    image: "statement.jpg",
    eyebrow: "Glowtech.",
    text: "Vi gör LED-ljus för hudvård som är enkelt att använda varje dag. Tio minuter, hemma, när det passar dig.",
    cta: "Om oss", href: "#om-oss"
  },

  // Editorial-galleri. Byt bilder genom att ändra listan (filnamn i Assets).
  // grayscale: false visar bilderna i färg. 32 bilder ger jämna rader på alla skärmar.
  gallery: {
    grayscale: true,
    eyebrow: "Glowtech world",
    title: "Built for recovery",
    cta: { label: "Upptäck mer", href: "#om-oss" },
    images: [
      "gallery-01.jpg", "gallery-02.jpg", "gallery-03.jpg", "gallery-04.jpg", "gallery-05.jpg", "gallery-06.jpg", "gallery-07.jpg", "gallery-08.jpg",
      "gallery-09.jpg", "gallery-10.jpg", "gallery-11.jpg", "gallery-12.jpg", "gallery-13.jpg", "gallery-14.jpg", "gallery-15.jpg", "gallery-16.jpg",
      "gallery-17.jpg", "gallery-18.jpg", "gallery-19.jpg", "gallery-20.jpg", "gallery-21.jpg", "gallery-22.jpg", "gallery-23.jpg", "gallery-24.jpg",
      "gallery-25.jpg", "gallery-26.jpg", "gallery-27.jpg", "gallery-28.jpg", "gallery-29.jpg", "gallery-30.jpg", "gallery-31.jpg", "gallery-32.jpg"
    ]
  },

  chat: { title: "Kundservice", text: "Svar inom ett dygn på vardagar. Mejla oss på din@epost.se." },

  footer: {
    about: "LED-ljus för hudvård hemma.",
    columns: [
      { title: "Shop", links: [["Alla produkter", "#produkter"], ["Paketpris", "#produkter"], ["Tillbehör", "#produkter"]] },
      { title: "Kundservice", links: [["Frakt och leverans", "#"], ["Retur och öppet köp", "#"], ["Kontakta oss", "#"]] },
      { title: "Om Glowtech", links: [["Om oss", "#om-oss"], ["Köpvillkor", "#"], ["Integritetspolicy", "#"]] }
    ],
    legal: "© 2026 Glowtech"
  }
};
window.GT_CONFIG = Object.assign({ imgBase: "/images/", currency: "SEK", images: {} }, window.GT_CONFIG || {});
